/**
 * Environment Configuration
 * Automatically switches between dev and prod URLs based on REACT_APP_ENV flag
 */

const ENV = process.env.REACT_APP_ENV || 'dev';

// Development URLs
const DEV_CONFIG = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL_DEV || 'http://localhost:5000',
  API_V2_BASE_URL: process.env.REACT_APP_API_V2_BASE_URL_DEV || 'http://localhost:8001',
};

// Production URLs
const PROD_CONFIG = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL_PROD || 'https://ocr-backoffice-backend-966597289997.europe-west1.run.app',
  API_V2_BASE_URL: process.env.REACT_APP_API_V2_BASE_URL_PROD || 'https://api-v2-966597289997.europe-west1.run.app',
};

// Select config based on environment
const config = ENV === 'prod' ? PROD_CONFIG : DEV_CONFIG;

export const API_BASE_URL = config.API_BASE_URL;
export const API_V2_BASE_URL = config.API_V2_BASE_URL;
export const ENVIRONMENT = ENV;

// Log current environment on startup (only in development)
if (process.env.NODE_ENV === 'development') {
  console.log('🌍 Environment:', ENV);
  console.log('🔗 API Base URL:', API_BASE_URL);
  console.log('🔗 API v2 Base URL:', API_V2_BASE_URL);
}
